import { Col, Form, Row, Select, Space } from 'antd';
import AddCategoryPage from './AddCategoryPage';
import { Content } from 'antd/lib/layout/layout';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Button from 'components/Button';
import ApproveCartDetail from '../../../components/Modules/Category/ApproveCartDetail';
import { DownloadIcon } from 'assets/svg';
import { useEffect, useState } from 'react';
import useCategoryManagementStore from 'store/categoryManagementStore';
import PopupConfirmBase from 'components/PopupConfirmBase';
import { useMutation, useQuery } from 'react-query';
import PortfolioApi from 'apis/PortfolioApi';
import { useUser } from 'contexts/User';
import { openNotificationWithIcon } from 'utils/notification';

interface Iparam {
  id?: string;
}

export default function ApproveStepPage(): JSX.Element {
  const history = useHistory();
  const { user } = useUser();
  const { id } = useParams<Iparam>();
  const location = useLocation<{ pof_type_code: string; pof_code: string }>();
  const [modalVisible, setModalVisible] = useState(false);
  const [approveSettings, setApproveSettings] = useState([]);
  const [form] = Form.useForm();

  const setStep = useCategoryManagementStore((state) => state.setStep);

  const { mutate: getApproveSettings, isLoading } = useMutation(
    ['getApproveSettings'],
    () =>
      PortfolioApi.getApproveSettings({
        ...(!user?.role.includes('admin') && {
          division_id: user?.division_id,
        }),
        pof_type_code: location.state?.pof_type_code,
      }),
    {
      onSuccess: (data: any) => {
        if (data.data && data.data.length != 0) {
          const list_setting = data.data[0].list_setting.filter(
            (item: any) => item.approve_stage !== 2
          );
          setApproveSettings(list_setting);
        }
      },
      onError: (e: any) => {
        openNotificationWithIcon('error', e.message);
      },
    }
  );

  useEffect(() => {
    setStep(2);
    if (user) {
      getApproveSettings();
    }
  }, [user?.division_id]);

  const onNextStep = (values: any) => {
    for (const key in values) {
      if (
        Object.prototype.hasOwnProperty.call(values, key) &&
        key.includes('emails')
      ) {
        const arr = values[key];

        for (let i = 0; i < arr.length; i++) {
          if (arr[i] == undefined) {
            openNotificationWithIcon(
              'error',
              'Vui lòng không được bỏ trống email'
            );
            return;
          }
        }
      }
    }

    const params: any = {
      pof_code: location.state?.pof_code,
      stage_1_PhatHanhDanhMuc: [],
      // stage_2_ChiNhanhDKMau: [],
      stage_3_DKGioHang_ChiNhanh: [],
      stage_4_DKGioHang_HoiSo: [],
    };

    const approve_stage_1: any = approveSettings.find(
      (item: any) => item.approve_stage == 1
    );
    const stage_1_PhatHanhDanhMuc = Array.from(
      { length: approve_stage_1?.approve_level },
      (_, index) => ({
        approve_level: index,
        approve_type: values['approve_type_1_' + index] ?? 0,
        date_end: 0,
        list_user: (values['emails_1_' + index] ?? []).map((item: any) => ({
          email: item,
        })),
      })
    );

    const approve_stage_3: any = approveSettings.find(
      (item: any) => item.approve_stage == 3
    );

    const stage_3_DKGioHang_ChiNhanh = Array.from(
      { length: approve_stage_3?.approve_level },
      (_, index) => ({
        approve_level: index,
        approve_type: values['approve_type_3_' + index] ?? 0,
        date_end: 0,
        list_user: (values['emails_3_' + index] ?? []).map((item: any) => ({
          email: item,
        })),
      })
    );

    const approve_stage_4: any = approveSettings.find(
      (item: any) => item.approve_stage == 4
    );

    const stage_4_DKGioHang_HoiSo = Array.from(
      { length: approve_stage_4?.approve_level },
      (_, index) => ({
        approve_level: index,
        approve_type: values['approve_type_4_' + index] ?? 0,
        date_end: 0,
        list_user: (values['emails_4_' + index] ?? []).map((item: any) => ({
          email: item,
        })),
      })
    );

    params['stage_1_PhatHanhDanhMuc'] = stage_1_PhatHanhDanhMuc;
    params['stage_3_DKGioHang_ChiNhanh'] = stage_3_DKGioHang_ChiNhanh;
    params['stage_4_DKGioHang_HoiSo'] = stage_4_DKGioHang_HoiSo;

    insertApproveDetail(params);
  };

  function handleCreate() {
    setModalVisible(false);
    history.push('/category');
  }

  const { mutate: insertApproveDetail, isLoading: isInsertApproveDetail } =
    useMutation(PortfolioApi.insertApproveDetail, {
      onSuccess: (data) => {
        console.log(data);
        // setModalVisible(true);
        // history.push('/add-category/product-list-step');
        openNotificationWithIcon('success', 'Tạo danh mục thành công');
        history.push('/category');
      },
      onError: (error: any) => {
        openNotificationWithIcon('error', error.mesage.toString());
      },
    });

  return (
    <AddCategoryPage isLoading={isInsertApproveDetail}>
      <Form
        form={form}
        layout="vertical"
        className="items-center"
        onFinish={onNextStep}
        autoComplete="off"
      >
        <Content>
          <Row justify="space-between" align="middle">
            <Col span={8}>
              <div
                className="text-xl font-bold"
                style={{ marginBottom: '24px' }}
              >
                3. Thiết lập phê duyệt
              </div>
            </Col>

            <Col span={8}>
              <Row justify="end" align="middle">
                <Space>
                  <div className="text-primary-50 text-base">Hướng dẫn</div>
                  <Button
                    bgColor={'white'}
                    border={'neutral-90'}
                    customClass={'no-show'}
                  >
                    <DownloadIcon />
                  </Button>
                </Space>
              </Row>
            </Col>
          </Row>

          {/* <Row>
            <Col className="" span={12}>
              <Form.Item
                name="cht_approve_date"
                label="Thời gian phê duyệt CHT"
                rules={[{ required: true }]}
              >
                <Select
                  placeholder="Thời gian phê duyệt CHT"
                  options={[{ value: 2, label: '2 Ngày' }]}
                ></Select>
              </Form.Item>
            </Col>
          </Row> */}

          {approveSettings.map((item: any) => (
            <>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-6">
                <Col className="" span={24}>
                  <div
                    className="text-sm font-bold"
                    style={{ fontSize: '18px' }}
                  >
                    {item.approve_stage == 1 ? (
                      '1. Phát hành danh mục'
                    ) : item.approve_stage == 3 ? (
                      <>
                        2. Đăng ký giỏ hàng danh mục
                        <br />
                        <br />
                        A. Chi nhánh (Chỉ phê duyệt đơn thuộc chi nhánh)
                      </>
                    ) : item.approve_stage == 4 ? (
                      'B. Hội sở'
                    ) : (
                      ''
                    )}
                  </div>
                </Col>
              </Row>
              {Array.from({ length: item.approve_level }, (_, index) => (
                <>
                  <Row
                    gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                    className="mb-6"
                  >
                    <Col className="" span={24}>
                      <div className="text-sm font-bold text-primary-50 pl-6">
                        Phê duyệt cấp {index + 1}
                      </div>
                    </Col>
                  </Row>
                  <ApproveCartDetail
                    id={item.approve_stage + '_' + index}
                    form={form}
                  />
                </>
              ))}
            </>
          ))}
        </Content>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
          <Col
            className="flex justify-end"
            span={8}
            style={{ marginTop: '20px', marginRight: '2px' }}
          >
            <Space>
              <Button type="submit">Tạo danh mục</Button>
            </Space>
          </Col>
        </Row>
      </Form>
      <PopupConfirmBase
        isVisible={modalVisible}
        title={'Thông báo'}
        description={'Tạo Danh mục thành công'}
        onlyOK={true}
        onOk={handleCreate}
      ></PopupConfirmBase>
    </AddCategoryPage>
  );
}
